import { defineMessages } from '@jutro/locale';

export default defineMessages({
    anErrorOccurred: {
        id: 'gw-portals-policytransaction-pc-pa.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-pc-pa.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-pc-pa.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-pc-pa.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    mlChooseEffectiveDate: {
        id: 'ml.gw-portals-policytransaction-pc-pa.mlChooseEffectiveDate',
        defaultMessage: 'Choose Effective Date'
    },
    mlReviewAddlInfo: {
        id: 'ml.gw-portals-policytransaction-pc-pa.mlReviewAddlInfo',
        defaultMessage: 'Review Additional Info'
    },
    mlEmployerAffiliation: {
        id: 'ml.gw-portals-policytransaction-pc-pa.mlEmployerAffiliation',
        defaultMessage: 'Employer/Affiliation'
    },
    mlExcludedDrivers: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    mlDrivers: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Drivers',
        defaultMessage: 'Drivers'
    },
    mlDriverDiscoveryReview: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Driver Discovery Review',
        defaultMessage: 'Driver Discovery Review'
    },
    mlVehicles: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Vehicles',
        defaultMessage: 'Vehicles'
    },
    mlHouseholdMembers: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Household Members',
        defaultMessage: 'Household Members'
    },
    nonDrivers: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    mlAdditionalPolicyInfo: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Additional Policy Info',
        defaultMessage: 'Additional Policy Info'
    },
    makeChanges: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Make Changes',
        defaultMessage: 'Make Changes'
    },
    mlQuoteDetails: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Quote Details',
        defaultMessage: 'Quote Details'
    },
    addresses: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Addresses',
        defaultMessage: 'Addresses'
    },
    ampDisclosuresTitle: {
        id: 'ml.endorsement.wizard.step.pa.Adjustments for your policy',
        defaultMessage: 'Adjustments for your policy'
    },
    confirmation: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Policy change confirmation',
        defaultMessage: 'Policy change confirmation'
    },
    loadingPolicyChange: {
        id: 'ml.gw-portals-policytransaction-pc-pa.Loading policy change',
        defaultMessage: 'Loading policy change'
    }
    
});
